"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isInstalmentTemplateDTO = exports.InstalmentTemplateDTOSchema = exports.ajv = void 0;
const tslib_1 = require("tslib");
/* eslint-disable @typescript-eslint/no-var-requires */ /* tslint:disable */
// generated by typescript-json-validator
const util_1 = require("util");
const ajv_1 = tslib_1.__importDefault(require("ajv"));
exports.ajv = new ajv_1.default({
    allErrors: true,
    coerceTypes: false,
    format: "fast",
    nullable: true,
    unicode: true,
    uniqueItems: true,
    useDefaults: true,
});
exports.ajv.addMetaSchema(require("ajv/lib/refs/json-schema-draft-06.json"));
exports.InstalmentTemplateDTOSchema = {
    $schema: "http://json-schema.org/draft-07/schema#",
    defaultProperties: [],
    definitions: {
        RemovedDTO: {
            defaultProperties: [],
            properties: {
                appType: {
                    $ref: "#/definitions/appType",
                    title: "appType",
                },
                comment: {
                    title: "comment",
                    type: "string",
                },
                removedAt: {
                    title: "removedAt",
                    type: "number",
                },
                removedBy: {
                    title: "removedBy",
                    type: "string",
                },
            },
            propertyOrder: ["removedBy", "removedAt", "appType", "comment"],
            required: ["removedAt", "removedBy"],
            title: "RemovedDTO",
            type: "object",
        },
        ResourceEventValueDTO: {
            defaultProperties: [],
            properties: {
                operation: {
                    $ref: "#/definitions/rsrcOperation",
                    title: "operation",
                },
                reason: {
                    $ref: "#/definitions/rsrcEventReason",
                    title: "reason",
                },
                type: {
                    $ref: "#/definitions/rsrcType",
                    title: "type",
                },
                value: {
                    title: "value",
                    type: "number",
                },
            },
            propertyOrder: ["type", "operation", "reason", "value"],
            required: ["operation", "reason", "type", "value"],
            title: "ResourceEventValueDTO",
            type: "object",
        },
        TrackerDTO: {
            defaultProperties: [],
            properties: {
                comment: {
                    title: "comment",
                },
                createdApp: {
                    $ref: "#/definitions/appType",
                    title: "createdApp",
                },
                createdAt: {
                    title: "createdAt",
                    type: "number",
                },
                createdBy: {
                    title: "createdBy",
                    type: "string",
                },
                key: {
                    title: "key",
                    type: "string",
                },
                previousValue: {
                    title: "previousValue",
                },
                updatedApp: {
                    $ref: "#/definitions/appType",
                    title: "updatedApp",
                },
                updatedAt: {
                    title: "updatedAt",
                    type: "number",
                },
                updatedBy: {
                    title: "updatedBy",
                    type: "string",
                },
            },
            propertyOrder: [
                "createdAt",
                "updatedAt",
                "createdBy",
                "updatedBy",
                "createdApp",
                "updatedApp",
                "previousValue",
                "comment",
                "key",
            ],
            required: ["createdApp", "createdAt", "createdBy", "updatedApp", "updatedAt", "updatedBy"],
            title: "TrackerDTO",
            type: "object",
        },
        appType: {
            enum: ["A", "GA", "I", "M", "SC", "SE", "T", "U", "W"],
            title: "appType",
            type: "string",
        },
        instalmentCode: {
            enum: ["ONCE_CREDIT_ONLY", "ONCE_STANDARD", "SUB_CUSTOM", "SUB_FREE", "SUB_PREMIUM", "SUB_PROMO", "SUB_STANDARD"],
            title: "instalmentCode",
            type: "string",
        },
        instalmentType: {
            enum: ["ONCE", "SUBSCRIPTION"],
            title: "instalmentType",
            type: "string",
        },
        rsrcEventReason: {
            enum: ["REFUND", "SUBSCRIPTION", "TASK", "TOPUP"],
            title: "rsrcEventReason",
            type: "string",
        },
        rsrcOperation: {
            enum: ["ADD", "SUBTR"],
            title: "rsrcOperation",
            type: "string",
        },
        rsrcType: {
            enum: ["CREDIT", "DOWNLOAD", "STORAGE", "UPLOAD"],
            title: "rsrcType",
            type: "string",
        },
    },
    properties: {
        comment: {
            title: "comment",
            type: "string",
        },
        durationDays: {
            title: "durationDays",
            type: "number",
        },
        includedResources: {
            additionalProperties: {
                $ref: "#/definitions/ResourceEventValueDTO",
            },
            defaultProperties: [],
            propertyOrder: [],
            title: "includedResources",
            type: "object",
        },
        instalmentCode: {
            $ref: "#/definitions/instalmentCode",
            title: "instalmentCode",
        },
        paymentIds: {
            additionalProperties: {
                type: "boolean",
            },
            defaultProperties: [],
            propertyOrder: [],
            title: "paymentIds",
            type: "object",
        },
        removed: {
            $ref: "#/definitions/RemovedDTO",
            title: "removed",
        },
        tracker: {
            $ref: "#/definitions/TrackerDTO",
            title: "tracker",
        },
        type: {
            $ref: "#/definitions/instalmentType",
            title: "type",
        },
    },
    propertyOrder: [
        "type",
        "durationDays",
        "includedResources",
        "instalmentCode",
        "paymentIds",
        "comment",
        "tracker",
        "removed",
    ],
    required: ["durationDays", "includedResources", "instalmentCode", "type"],
    type: "object",
};
exports.isInstalmentTemplateDTO = exports.ajv.compile(exports.InstalmentTemplateDTOSchema);
function validate(value) {
    if (exports.isInstalmentTemplateDTO(value)) {
        return value;
    }
    else {
        throw new Error(exports.ajv.errorsText(exports.isInstalmentTemplateDTO.errors.filter((e) => e.keyword !== "if"), { dataVar: "InstalmentTemplateDTO" }) +
            "\n\n" +
            util_1.inspect(value));
    }
}
exports.default = validate;
//# sourceMappingURL=InstalmentTemplate.validator.js.map